import React, { useState,useEffect } from "react";
import emailjs from "@emailjs/browser";
import { FaLinkedin, FaGithub, FaEnvelope } from "react-icons/fa";
import "./Contact.css";
import AOS from "aos";
import "aos/dist/aos.css";

const Contact = () => {
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleEmailSubmit = (e) => {
    e.preventDefault();

    // Get values from form fields
    const name = e.target.elements.name.value;
    const email = e.target.elements.email.value;
    const message = e.target.elements.message.value;

    // Validate fields
    if (!name || !email || !message) {
      setErrorMessage("Please fill in all fields.");
      setTimeout(() => {
        setErrorMessage(null);
      }, 5000);
      return;
    }

    // Send email if all fields are filled
    emailjs
      .sendForm(
        "service_1syl12s",
        "template_4p55dpn",
        e.target,
        "hdhhKDt974Ji64omZ"
      )
      .then((res) => {
        console.log(res);
        setSuccessMessage("Email sent successfully!");
        setTimeout(() => {
          setSuccessMessage(null);
        }, 5000); // Hide success message after 5 seconds
      })
      .catch((err) => {
        console.error(err);
        setErrorMessage("Failed to send email. Please try again.");
        setTimeout(() => {
          setErrorMessage(null); // Clear error message after 5 seconds
        }, 5000);
      });
  };

  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 200,
      easing: "ease-in-sine",
      delay: 50,
    });
  }, []);

  return (
    <section className="contact">
      <div className="contact-container">
        <h2 className="contact-title">Contact Me</h2>
        <div className="contact-content">
          <form className="form" onSubmit={handleEmailSubmit} data-aos="fade-left">
            <div className="flex-column">
              <label htmlFor="name">Name </label>
            </div>
            <div className="inputForm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 100 100"
              >
                <g data-name="Layer 3" id="Layer_3">
                  <path
                    d="M10 90 L10 10 L80 90 L80 10"
                    stroke="black"
                    strokeWidth="6"
                    fill="none"
                  />
                </g>
              </svg>
              <input
                placeholder="Enter your Name"
                className="input"
                type="text"
                id="name"
                name="from_name"
              />
            </div>

            <div className="flex-column">
              <label htmlFor="email">Email </label>
            </div>
            <div className="inputForm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                viewBox="0 0 32 32"
                height="20"
              >
                <g data-name="Layer 3" id="Layer_3">
                  <path d="m30.853 13.87a15 15 0 0 0 -29.729 4.082 15.1 15.1 0 0 0 12.876 12.918 15.6 15.6 0 0 0 2.016.13 14.85 14.85 0 0 0 7.715-2.145 1 1 0 1 0 -1.031-1.711 13.007 13.007 0 1 1 5.458-6.529 2.149 2.149 0 0 1 -4.158-.759v-10.856a1 1 0 0 0 -2 0v1.726a8 8 0 1 0 .2 10.325 4.135 4.135 0 0 0 7.83.274 15.2 15.2 0 0 0 .823-7.455zm-14.853 8.13a6 6 0 1 1 6-6 6.006 6.006 0 0 1 -6 6z"></path>
                </g>
              </svg>
              <input
                placeholder="Enter your Email"
                className="input"
                type="email"
                id="email"
                name="from_email"
              />
            </div>

            <div className="flex-column">
              <label htmlFor="message">Message </label>
            </div>
            <textarea
              placeholder="Say Hello"
              rows="10"
              cols="30"
              id="message"
              name="message"
              className="textarea"
            ></textarea>

            <button type="submit" className="button-submit">
              Submit
            </button>
          </form>
          {/* Success message */}
          {successMessage && (
            <div className="notification success">{successMessage}</div>
          )}
          {/* Error message */}
          {errorMessage && (
            <div className="notification error">{errorMessage}</div>
          )}
          <div className="socials" data-aos="fade-right">
            <h2>
              <span>Let's</span> Connect! <span className="emoji"> 😊</span>
            </h2>
            <p>
              If you'd like to reach out or connect with me, feel free to find
              me on the following platforms:
            </p>
            <div className="social-links">
              <a
                href="https://www.linkedin.com/in/martha-mwau-5b84ab239/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <FaLinkedin className="social-icon" />
                <span>LinkedIn</span>
              </a>
              <a
                href="https://github.com/MarsMwau"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <FaGithub className="social-icon" />
                <span>GitHub</span>
              </a>
              <a href="mailto:marthamwau16@gmail.com" className="social-link">
                <FaEnvelope className="social-icon" />
                <span>Mail</span>
              </a>
            </div>
            <p>
              Feel free to connect with me on any of these platforms! I'm always
              happy to chat and collaborate.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
